import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { IRiderAlert } from 'app/core/models/rider-alert.model';
import { BooleanCheckComponent } from 'app/pages/A2-utils/grid-components/boolean-check/boolean-check.component';
import { T2CardComponent } from 'app/trip2-theme/components/t2-card/t2-card.component';
import * as moment from 'moment';
import { SweetAlertOptions, SweetAlertResult } from 'sweetalert2';
import { RiderAlertService } from '../../services/rider-alert.service';
import { SweetAlertHelper } from '../../../../core/helpers/sweet-alert-helper.service';

@Component({
  selector: 'app-rider-alerts',
  templateUrl: './rider-alerts.component.html',
  styleUrls: ['./rider-alerts.component.scss']
})
export class RiderAlertsComponent implements OnInit {

  @Input() riderId: number;
  @Input() isDisableRider: boolean;

  @ViewChild('modal') modal: T2CardComponent;

  selectedAlert: IRiderAlert;
  gridOptions: GridOptions;
  isActive: boolean;
  disbaledDeleteBtn: boolean;

  constructor(
    private riderAlertService: RiderAlertService,
    private sweetAlertHelper: SweetAlertHelper,
    ) { }

  ngOnInit() {
    this.createGrid();
    this.getAlerts();
  }

  private getAlerts() {
    this.riderAlertService.getAlertsByRiderId(this.riderId, this.isActive).subscribe(
      (alerts: IRiderAlert[]) => {
        if (alerts) {
          this.gridOptions.api.setRowData(alerts);
        }
      }
    );
    this.disbaledDeleteBtn = false;
  }

  private createGrid() {
    this.gridOptions = {
      columnDefs: [
        {
          headerName: '',
          width: 50,
          checkboxSelection: true
        },
        {
          headerName: 'Id',
          field: 'rideralertid',
          width: 60
        },
        {
          headerName: 'Date',
          field: 'addedon',
          width: 100,
          cellRenderer: (params) => {
            return this.formatedDate(params.data.addedon, 1);
          }
        },
        {
          headerName: 'Time',
          field: 'addedon',
          width: 80,
          cellRenderer: (params) => {
            return this.formatedDate(params.data.addedon, 2);
          }
        },
        {
          headerName: 'Alert',
          field: 'description',
          width: 290
        },
        {
          headerName: 'User',
          field: 'userprofile.fullname',
          width: 130
        },
        {
          headerName: 'Type',
          field: 'alerttype.description',
          width: 100
        },
        {
          headerName: 'Active',
          field: 'isactive',
          cellRendererFramework: BooleanCheckComponent,
          colId: 'isactive',
          width: 80,
        },
      ],
      onGridReady: () => {
        if (this.gridOptions.api) {
          this.gridOptions.api.sizeColumnsToFit();
        }
      },
      onRowDoubleClicked: ({ data }) => {
        this.selectedAlert = data;
        this.modal.open();
      },
      onRowSelected: () => {
        this.isRowSelected();
      },
      rowData: []
    };
  }

  isRowSelected() {
    const selected = this.gridOptions.api.getSelectedNodes();
    if (selected.length && selected[0].data.isactive) {
      this.disbaledDeleteBtn = true;
    } else {
      this.disbaledDeleteBtn = false;
    }
  }

  openModal() {
    this.modal.open();
  }

  onClose() {
    this.modal.close();
  }
  /**
   * @description al cerrar el modal
   */
  onCloseModal(modal: { isOpen: boolean, isMinimized: boolean }) {
    if (!modal.isOpen) {
      this.selectedAlert = null;
    }
  }
  onDelete() {
    const { api } = this.gridOptions;
    if (api.getSelectedNodes().length) {
      (this.sweetAlertHelper.createCustomAlert(
        {
          title: 'Are you sure you want to delete this alert?',
          type: 'warning',
          showConfirmButton: true,
          confirmButtonText: 'Yes'
        } as SweetAlertOptions
      ) as Promise<SweetAlertResult>).then(
        ({ value }) => {
          if (value) {
            const { rideralertid } = api.getSelectedRows()[0] as IRiderAlert;
            this.delete(rideralertid);
          }
        }
      );
    } else {
      this.sweetAlertHelper.createCustomAlert(
        {
          title: 'Select a row',
          toast: true,
          position: 'top-right',
          type: 'warning',
          showConfirmButton: false
        } as SweetAlertOptions
      );
    }
  }

  onUpdate() {
    this.getAlerts();
  }

  private delete(id: number) {
    this.riderAlertService.deleteAlert(id).subscribe(
      ({ success, message }) => {
        this.sweetAlertHelper.createCustomAlert(
          {
            title: message,
            type: success ? 'success' : 'error'
          } as SweetAlertOptions
        );
        this.getAlerts();
      }
    );
  }

  formatedDate(addedon: Date, idNumber: number) {
    const date = moment(addedon).format('MM-DD-YYYY');
    const time = moment(addedon).format('HH:mm:ss');
    return idNumber === 1 ? date : time;
  }

  showInactive(isActive: boolean) {
    this.isActive = isActive;
    this.getAlerts();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/rider/components/rider-alerts/rider-alerts.component.ts